import type { Router } from '@angular/router';
import { HttpStatusCode } from '@angular/common/http';
import type { TimesheetService } from '../services/timesheet.service';
import type { SnackbarService } from '../../../services/snack-service/snackbar-service';
import {
  hasMyTimesheetDeepLinkDateAttempt,
  parseMyTimesheetDeepLink,
  queryParamMapFromUrl,
} from '../utils/my-timesheet-deep-link.util';

/** Shared bootstrap for guard + shell component + TimesheetComponent. */
export function applyMyTimesheetDeepLinkFromUrl(
  router: Router,
  timesheetService: TimesheetService,
  url: string,
  snackbar?: SnackbarService,
): boolean {
  if (!url.includes('/timesheet/my-timesheet')) return false;
  const qp = queryParamMapFromUrl(router, url);
  const deepLink = parseMyTimesheetDeepLink(qp);
  if (deepLink) {
    timesheetService.applyDeepLink(deepLink);
    return true;
  }
  if (hasMyTimesheetDeepLinkDateAttempt(qp)) {
    snackbar?.show(
      'Invalid link',
      'Timesheet date in this link is invalid. Showing the current view.',
      HttpStatusCode.BadRequest,
    );
  }
  return false;
}
